import { Switch, Redirect } from "react-router";
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import ErrorRoute from './ErrorRoute';
import {
    Login,
    ForgotPassword,
    ResetPassword,
    ChangePassword
} from 'views/Account';
import {
    Error403,
    Error404,
    Tickets,
    Ticket,
    NewTicket,
    BulkEdit,
    TicketPrint,
    CookiesPolicy
} from 'views';
import {
    TicketTypes,
    TicketType,
    TicketStatuses,
    TicketStatus,
    UserGroup,
    UserGroups,
    Users,
    User,
    Customer,
    Customers,
    Priority,
    Priorities,
    ReferenceData,
    ReferenceDataDetail,
    AssegneeSuggestions,
    AssegneeSuggestion
} from 'views/Admin';



let Routes = () => {
    return (
        <Switch>
            <ErrorRoute exact path="/error404" component={Error404} />
            <ErrorRoute exact path="/error403" component={Error403} />

            <PrivateRoute exact path="/" component={Tickets} />
            <PrivateRoute exact path="/ticket/addnew" component={NewTicket} />
            <PrivateRoute exact path="/ticket/:id" component={Ticket} />
            <PrivateRoute exact path="/ticket/print/:id" component={TicketPrint} hideLayout />

            <PrivateRoute exact path="/bulkEdit/:id" component={BulkEdit} />

            <PrivateRoute exact path="/admin/tickettypes" component={TicketTypes} />
            <PrivateRoute exact path="/admin/tickettype/addnew" component={TicketType} />
            <PrivateRoute exact path="/admin/tickettype/:id" component={TicketType} />

            <PrivateRoute exact path="/admin/ticketstatus" component={TicketStatuses} />
            <PrivateRoute exact path="/admin/ticketstatus/addnew" component={TicketStatus} />
            <PrivateRoute exact path="/admin/ticketstatus/:id" component={TicketStatus} />

            <PrivateRoute exact path="/admin/usergroups" component={UserGroups} />
            <PrivateRoute exact path="/admin/usergroup/addnew" component={UserGroup} />
            <PrivateRoute exact path="/admin/usergroup/:id" component={UserGroup} />

            <PrivateRoute exact path="/admin/users" component={Users} />
            <PrivateRoute exact path="/admin/user/addnew" component={User} />
            <PrivateRoute exact path="/admin/user/:id" component={User} />

            <PrivateRoute exact path="/admin/customers" component={Customers} />
            <PrivateRoute exact path="/admin/customer/addnew" component={Customer} />
            <PrivateRoute exact path="/admin/customer/:id" component={Customer} />

            <PrivateRoute exact path="/admin/ticketPriorites" component={Priorities} />
            <PrivateRoute exact path="/admin/ticketPriority/addnew" component={Priority} />
            <PrivateRoute exact path="/admin/ticketPriority/:id" component={Priority} />

            <PrivateRoute exact path="/admin/referenceData" component={ReferenceData} />
            <PrivateRoute exact path="/admin/referenceDataDetail/addnew" component={ReferenceDataDetail} />
            <PrivateRoute exact path="/admin/referenceDataDetail/:id" component={ReferenceDataDetail} />

            <PrivateRoute exact path="/admin/assegneeSuggestions" component={AssegneeSuggestions} />
            <PrivateRoute exact path="/admin/assegneeSuggestion/addnew" component={AssegneeSuggestion} />
            <PrivateRoute exact path="/admin/assegneeSuggestion/:id" component={AssegneeSuggestion} />

            <PublicRoute exact path="/account/login" component={Login} />
            <PublicRoute exact path="/account/changepassword" component={ChangePassword} />
            <PublicRoute exact path="/account/forgotpassword" component={ForgotPassword} />
            <PublicRoute exact path="/account/resetpassword" component={ResetPassword} />

            <PublicRoute exact path="/site-terms/cookies-policy" component={CookiesPolicy} />

            <Redirect to="/error404" />
        </Switch>
    )
}

export default Routes;